import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-228" data-mp="jvw6ibapi75c">
      {eyebrow && <p className="mb-3 font-display text-xs font-extrabold uppercase tracking-[0.2em] text-navy/60" data-id="element-229" data-mp="f4xptalt371k">{eyebrow}</p>}
      <h2 className="font-display text-2xl font-black uppercase leading-tight tracking-tight text-navy md:text-3xl" data-id="element-230" data-mp="ttk7vk2ticwh">{title}</h2>
      {subtitle && <div className="mt-4 text-base leading-relaxed text-navy/80" data-id="element-231" data-mp="ou7j2tsdyvr9">{subtitle}</div>}
    </div>;
}